import React, { Fragment }  from 'react';
import './App.css';
import './components/certifierUI';
import DmdcuHeader from './components/dmdcuHeader';
import DmdcuBody from './components/dmdcuBody';
// import CertifierUI from './components/certifierUI';
// import ModificationUI from './components/modificationUI';
import { DmdcuDataContext } from './api/dmdcuDataContext';
import Web3 from 'web3';

function App() {

  const web3 = new Web3('https://rpc.sigma1.artis.network');
  // this snipped lets you impersonate for admin purposes.
  // const account = web3.eth.accounts.privateKeyToAccount('');
  // web3.eth.accounts.wallet.add(account);
  // web3.eth.defaultAccount = account.address;
  const dataContext = new DmdcuDataContext(web3, '0x430354eB17200febcA60d0BfADC89608dF20639e');

  // const testHex = dataContext.api.motorCycleValuesToHexString(50, 200, 250, 1, 2);
  // console.log('testHex: ' + testHex);

  // const motorcycleValues = dataContext.api.convertRawDataToMotoValues(testHex);
  // console.log('motoValues: ', motorcycleValues);

  // dataContext.impersonateViaPK('0x2425326d10a6d8be659b568d685490445abafa6e790330a2dd4586ea09922d65');
  // dataContext.api.addNewCertifier('', 'Monaco Demo Certifier', '', '0x70A830C7EffF19c9Dd81Db87107f5Ea5804cbb3F', '', '', '');

  return (
    <Fragment>
      <DmdcuHeader dataContext={dataContext} />
      <DmdcuBody dataContext={dataContext} />
    </Fragment>
  );
}

export default App;
